import { createRouter, createWebHistory } from 'vue-router';
import { sendTrack } from '@/utils/analytics';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'home', component: () => import('@/pages/Home.vue') },
    { path: '/blog', name: 'blog', component: () => import('@/pages/Blog.vue') },
    { path: '/blog/:slug', name: 'post', component: () => import('@/pages/Post.vue'), props: true },
    { path: '/notes', name: 'notes', component: () => import('@/pages/Notes.vue') },
    { path: '/notes/:slug', name: 'note', component: () => import('@/pages/Post.vue'), props: true },
    { path: '/now', name: 'now', component: () => import('@/pages/Now.vue') },
    { path: '/works', name: 'works', component: () => import('@/pages/Works.vue') },
    { path: '/works/:slug', name: 'work', component: () => import('@/pages/Work.vue'), props: true },
    { path: '/skills', name: 'skills', component: () => import('@/pages/ToolDirectory.vue'), props: { kind: 'SKILL' } },
    { path: '/skills/:slug', name: 'skill', component: () => import('@/pages/ToolDetail.vue'), props: (to) => ({ kind: 'SKILL', slug: to.params.slug }) },
    { path: '/mcps', name: 'mcps', component: () => import('@/pages/ToolDirectory.vue'), props: { kind: 'MCP' } },
    { path: '/mcps/:slug', name: 'mcp-catalog', component: () => import('@/pages/ToolDetail.vue'), props: (to) => ({ kind: 'MCP', slug: to.params.slug }) },
    // 兼容常见单数写法与历史 /work 导航，统一收敛到正式复数路径。
    { path: '/skill', redirect: '/skills' },
    { path: '/skill/:slug', redirect: (to) => `/skills/${to.params.slug}` },
    { path: '/mcp', redirect: '/mcps' },
    { path: '/mcp/:slug', redirect: (to) => `/mcps/${to.params.slug}` },
    { path: '/work', redirect: '/works' },
    { path: '/work/:slug', redirect: (to) => `/works/${to.params.slug}` },
    { path: '/about', name: 'about', component: () => import('@/pages/About.vue') },
    // 站长自定义页面 (关于我 / Uses / 友链…)，标题由 Page.vue 自管 (App.vue 跳过 page)
    { path: '/p/:slug', name: 'page', component: () => import('@/pages/Page.vue'), props: true },
    // 偏好设置 (背景效果切换等)，纯前端 localStorage，不进 nav —— Footer 有入口
    { path: '/settings', name: 'settings', component: () => import('@/pages/Settings.vue') },
    // 隐藏的打字闯关游戏，题库取自已发布 Post —— 不进 nav，靠访客自己发现 / 文章引导
    { path: '/wpm', name: 'wpm', component: () => import('@/pages/Wpm.vue') },
    { path: '/:catchAll(.*)', name: 'not-found', component: () => import('@/pages/NotFound.vue') },
  ],
  scrollBehavior(to, from, saved) {
    if (saved) return saved;
    // 同页仅 query 变化（如 Notes 分类切换 ?cat=）不滚动到顶，保持当前阅读位置
    if (to.path === from.path) return false;
    return { top: 0, behavior: 'smooth' };
  },
});

// PV 上报：每次成功导航后异步打到后端，失败静默
router.afterEach((to, from) => {
  if (to.fullPath === from.fullPath) return;
  // 同站切换 document.referrer 通常为空，回填上一页路径让 admin 看到内部跳转链路
  const referer = document.referrer || (from.fullPath !== '/' ? from.fullPath : null);
  sendTrack(to.fullPath, referer);
});

export default router;
